export const getSkipCount = (page: number, itemsPerPage: number) =>
  (page - 1) * itemsPerPage;
